// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"28212800","440":"d06e1e04","453":"666492b6"}[chunkId] + ".chunk.js";
};